import React from 'react';
import Bugsnag from '@bugsnag/js';
import BugsnagPluginReact from '@bugsnag/plugin-react';
import BugsnagPerformance from '@bugsnag/browser-performance';
import { shouldDiscardBugsnagEvent } from 'utils/bugsnag/shouldDiscardEvent';

const KEY = 'aa45faf62ad0a0e5951d6bb059f58bd3';
let bugsnagClient;
let ErrorBoundary;

//  process.env.TESTING -> check exceptions in tests environments
export const initBugsnag = (metaData) => {
    if (process.env.NODE_ENV === 'development' && !process.env.TESTING) return;
    bugsnagClient = Bugsnag.start({
        // file deepcode ignore HardcodedNonCryptoSecret: public key
        apiKey: KEY,
        appVersion: process.env.VERSION,
        plugins: [new BugsnagPluginReact(React)],
        onError: (event) => !shouldDiscardBugsnagEvent(event),
    });
    BugsnagPerformance.start({ apiKey: KEY });
    ErrorBoundary = Bugsnag.getPlugin('react').createErrorBoundary(React);
};

// `fallback` is injected by the caller to keep this bootstrap module free of UI imports.
export const BugSnagWrapper = ({ children, fallback }) => {
    if (process.env.NODE_ENV === 'development' && !process.env.TESTING) return children;
    return <ErrorBoundary FallbackComponent={fallback}>{children}</ErrorBoundary>;
};

export const notifyBugsnagError = (error) => {
    if (process.env.NODE_ENV === 'development' && !process.env.TESTING) return;
    if (!bugsnagClient) initBugsnag();
    bugsnagClient.notify(error);
};

export const setBugsnagUser = ({
    idUsuario,
    user,
    implementacion,
    idImplementacion,
    langISODDBB,
    langISOInterface,
    locale,
}) => {
    if (process.env.NODE_ENV === 'development' && !process.env.TESTING) return;
    if (!bugsnagClient) initBugsnag();
    bugsnagClient.setUser(idUsuario, user);
    bugsnagClient.addMetadata('config', {
        langDB: langISODDBB,
        langUI: langISOInterface,
        locale,
        implementationId: idImplementacion,
        implementation: implementacion,
    });
};
